import React, { useState } from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

const CallrateModal = ({ setShowCallRateModal, showCallRateModal }) => {

    const [show, setShow] = useState(showCallRateModal ? showCallRateModal : false);
    const handleClose = () => {

        localStorage.removeItem("call_rate");
        localStorage.removeItem("call_time");
        setShow(false)
        setShowCallRateModal(false)
    };

    const call_rate = localStorage.getItem('call_rate')
    const call_time = localStorage.getItem('call_time')
    useEffect(() => {
        if (call_rate && call_time && localStorage?.getItem("user_type") == 1) {
            setShow(true)
        }
    }, [call_rate, call_time])

    return (
        <React.Fragment>
            <>
                {/* <Button variant="primary" onClick={handleShow}>
                    Launch demo modal
                </Button> */}

                <Modal className='call_duration_modal' show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Call Log</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h3 className='call_duration'>Last call duration : {call_time + String(' min')}</h3>
                        <h3 className='call_charge'>Last call charge : ₹ {call_rate}</h3>
                    </Modal.Body>

                    {/* <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleClose}>
                            Save Changes
                        </Button>
                    </Modal.Footer> */}
                </Modal>
            </>
        </React.Fragment>
    )
}

export default CallrateModal;